import { render, staticRenderFns } from "./ModalContainer.vue?vue&type=template&id=01451667&"
import script from "./ModalContainer.vue?vue&type=script&lang=js&"
export * from "./ModalContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports